export default __webpack_public_path__ + "static/client1-55c6e6b60034a4ac4fe59bfb24aabc45.png";